import React from 'react';
import User from '../../route/user.route';
import { StyleProvider } from '@ant-design/cssinjs';
import Header from '../header';
import Footer from '../footer';

import blog from '../../assets/icon/blog.png';
import speed from '../../assets/icon/speedometer.png';

import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from 'antd';
import { useDevice } from "../../hooks";
import BottomNav from '../bottomNav';
import {
    HomeFilled,
    AppstoreFilled,
    ReadFilled,
    MedicineBoxFilled,
    UserOutlined
} from "@ant-design/icons";


export default function DefaultLayoutUser() {

    const cykNavigate = useNavigate();
    const cykLocation = useLocation();
    const cykPath = cykLocation?.pathname || "/";

    let cykUser = null;

    try {
        cykUser = JSON.parse(localStorage.getItem("user"));
    } catch (e) {
        cykUser = null;
    }

    const cykDesktopNavItems = [
        {
            label: "Trang chủ",
            icon: <HomeFilled />,
            active: cykPath === "/",
            click: () => cykNavigate("/")
        },
        {
            label: "Danh mục",
            icon: <AppstoreFilled />,
            active:
                cykPath.startsWith("/danh-muc-san-pham") ||
                cykPath.startsWith("/danh-muc-moi") ||
                cykPath.startsWith("/danh-muc-con"),
            click: () =>
                cykNavigate("/danh-muc-san-pham/Sach-and-Tai-Lieu")
        },
        {
            label: "Blog",
            icon: <ReadFilled />,
            active:
                cykPath === "/blog" ||
                cykPath.startsWith("/blog/"),
            click: () => cykNavigate("/blog")
        },
        {
            label: "Tiện ích",
            icon: <MedicineBoxFilled />,
            active:
                cykPath === "/tienich" ||
                cykPath.startsWith("/tienich/"),
            click: () => cykNavigate("/tienich")
        },
        {
            label: "Tài khoản",
            icon: <UserOutlined />,
            active:
                cykPath.startsWith("/thong-tin-ca-nhan") ||
                cykPath.startsWith("/sach-cua-toi") ||
                cykPath.startsWith("/dang-nhap"),
            click: () =>
                cykNavigate(
                    cykUser
                        ? "/thong-tin-ca-nhan"
                        : "/dang-nhap"
                )
        }
    ];


    const location = useLocation();
    const { isMobile } = useDevice();

    /*
        TRANG DANH MỤC MỚI

        Hiện tại menu mobile đang dẫn tới:
        /danh-muc-san-pham/sach-and-tai-lieu

        Vì vậy trên mobile chúng ta ẩn Footer
        cho toàn bộ đường dẫn /danh-muc-san-pham/
    */
    const isNewCategoryPage =
        location?.pathname === "/danh-muc-moi" ||
        location?.pathname?.startsWith("/danh-muc-san-pham/");

    /*
        CHỈ ẨN FOOTER TRÊN MOBILE.

        Desktop vẫn có thể giữ cấu trúc cũ.
    */
    const hideFooter =
        isMobile &&
        (
            isNewCategoryPage ||
            location?.pathname === "/"
        );


    return (

        <StyleProvider hashPriority="high">

            <div className='cyk-user-layout-shell app-shell bg-[#efefef]'>

                {/* HEADER */}
                <Header />


                {/* NỘI DUNG TRANG */}
                <div className="app-page-content">
                    <User />
                </div>


                {/* ==============================
                    FOOTER
                ============================== */}

                {!hideFooter && (

                    location?.pathname === "/" ||

                    location?.pathname?.includes(
                        "danh-muc-trang-chu"
                    ) ||

                    location?.pathname?.includes(
                        "danh-muc-san-pham"
                    ) ||

                    location?.pathname?.includes(
                        "danh-muc-con"
                    ) ||

                    (
                        !location?.pathname?.includes(
                            "/kiem-tien/"
                        ) &&
                        location?.pathname?.includes(
                            "/kiem-tien"
                        )
                    ) ||

                    location?.pathname?.includes(
                        "cong-cu"
                    ) ||

                    location?.pathname?.includes(
                        "/nhiem-vu-kiem-tien"
                    )

                    ? (

                        <Row className='max-w-screen-2xl mx-auto'>

                            <Col xs={24} xl={4}></Col>


                            {isMobile && (

                                location?.pathname?.includes(
                                    "cong-cu"
                                ) ||

                                location?.pathname?.includes(
                                    "kiem-tien"
                                )

                            ) ? (

                                <Col xs={24} xl={20}>
                                </Col>

                            ) : (

                                <Col xs={24} xl={20}>

                                    {!location?.pathname?.includes(
                                        "/sach-cua-toi/"
                                    ) && (

                                        <Footer />

                                    )}

                                </Col>

                            )}

                        </Row>

                    ) : (

                        <>

                            {!location?.pathname?.includes(
                                "/sach-cua-toi/"
                            ) && (

                                <Footer />

                            )}

                        </>

                    )

                )}


                {/* ==============================
                    NAVIGATION
                    Mobile: bottom nav
                    Tablet/Desktop: side nav
                ============================== */}

                {!isMobile ? (
                    <nav className="cyk-desktop-side-nav">
                        {cykDesktopNavItems.map((item) => (
                            <button
                                key={item.label}
                                type="button"
                                onClick={item.click}
                                className={`cyk-desktop-side-item ${
                                    item.active ? "is-active" : ""
                                }`}
                                title={item.label}
                            >
                                <span className="cyk-desktop-side-icon">
                                    {item.icon}
                                </span>

                                <span className="cyk-desktop-side-label">
                                    {item.label}
                                </span>
                            </button>
                        ))}
                    </nav>
                ) : (
                    <BottomNav />
                )}

            </div>

        </StyleProvider>

    );

}
